import React from "react";
import PropTypes from "prop-types";

const NotificationBadge = ({
  count,
  maxCount = 99,
  className = "",
  width = "auto",
  height = "20px",
  minWidth = "20px",
  fontSize = "text-xs",
}) => {
  if (!count || count <= 0) return null;

  const displayCount = count > maxCount ? `${maxCount}+` : count.toString();

  const sizeStyles = {
    width: width === "auto" ? "auto" : width,
    height: height,
    minWidth: minWidth,
  };

  return (
    <span
      className={`
        inline-flex items-center justify-center
        bg-[#EF4056] text-white font-medium
        rounded-full px-1
        ${fontSize}
        ${className}
      `}
      style={sizeStyles}
    >
      {displayCount}
    </span>
  );
};

NotificationBadge.propTypes = {
  count: PropTypes.number.isRequired,
  maxCount: PropTypes.number,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  minWidth: PropTypes.string,
  fontSize: PropTypes.string,
};

export default NotificationBadge;
